import { useDispatch, useSelector } from 'react-redux';

// Export typed versions of the Redux hooks
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;
